import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-manager-statistics',
  templateUrl: './manager-statistics.component.html',
  styleUrls: ['./manager-statistics.component.css']
})
export class ManagerStatisticsComponent implements OnInit {

  @Input() userManagerStatistics: any;
  math = Math;

  percent: string;
  color: string;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(){
    if(this.userManagerStatistics.sales != undefined){
      this.percent = this.userManagerStatistics.sales[0].ksp + '%';
      if(this.userManagerStatistics.sales[0].ksp >= 90){
        this.color = '#ADB837';
      }
      else if(this.userManagerStatistics.sales[0].ksp >= 80 && this.userManagerStatistics.sales[0].ksp < 90) {
        this.color = '#FFA500'; //FFA500
      }
      else if(this.userManagerStatistics.sales[0].ksp < 80 ) {
        this.color = 'red'; 
      }
    }
  }

}
